import {
  CompassIcon as Compass,
  CodeIcon as Code,
  FactoryIcon as Factory,
  PlugsConnectedIcon as PlugsConnected,
  RobotIcon as Robot,
  MagnifyingGlassIcon as MagnifyingGlass,
} from "@phosphor-icons/react";

const MAP = {
  Compass,
  Code,
  Factory,
  PlugsConnected,
  Robot,
  Magnifier: MagnifyingGlass,
};

export default function AgentIcon({ name, size = 24, weight = "regular", color }) {
  const Icon = MAP[name] || Compass;
  return <Icon size={size} weight={weight} color={color} />;
}
